import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {useWindowSize} from '../../hooks/useWindowSize';
import ContentRow from '../ContentRow';
import DKidsGamesCarousel from '../DKidsGamesCarousel';
import GameRecentView from '../GameRecentView';

const DKidsGames = ({games, onClickItem}) => {
    const headerGames = games.slice(0, 3);
    const {width} = useWindowSize();
    const {t} = useTranslation();
    const adventureGames = games.filter(
        game => game.internationalCategory === 'Educational',
    );

    return (
        <Container>
            <PlayAreaHeader />
            <Title>{t('dkids.playArea')}</Title>
            <DKidsGamesCarousel games={headerGames} />
            <GameRecentView
                allGames={games}
                width={Math.min(width, 1440)}
                handleClickGame={onClickItem}
            />
            <CustomContentRow
                title={t('dkids.homeRow')}
                titleAlign="left"
                items={adventureGames}
                onClickContent={onClickItem}
                type="games"
            />
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
`;

const PlayAreaHeader = styled.img.attrs({
    src: require('../../assets/dkids/play-area-bg.png'),
})`
    width: 100%;
    aspect-ratio: 7.74;
    top: -40px;
`;

const CustomContentRow = styled(ContentRow)`
    margin-top: 50px;
    max-width: 1440px;
`;

const Title = styled.div`
    font-family: DKIDS;
    font-size: 26px;
    margin-top: -20px;
    margin-bottom: 10px;
`;

export default DKidsGames;
